const KeenSlider = window.KeenSlider

const { setInitialised, useDots } = window.BAO.Carousel.plugins

class HeroCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
        },
      },
      [setInitialised(), useDots(this.els.dot.elements)],
    )
  }
}

if (!customElements.get('hero-carousel')) {
  customElements.define('hero-carousel', HeroCarousel)
}
